/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material'
import React from 'react'
import { liveLayoutContentWrapperStyle } from './styles/LiveLayout.styles'
import LiveNavbar from './components/Live.Navbar'

type RiskLayoutProps = { children?: React.ReactNode }

export const LiveLayout = ({ children }: RiskLayoutProps) => {
  return (
    <Box>
      <LiveNavbar />
      <Box css={liveLayoutContentWrapperStyle}>{children}</Box>
    </Box>
  )
}

export default LiveLayout
